/* eslint-disable react/require-default-props */
import React, { useRef, useState } from 'react';
import { Button } from '../../atoms/Button/Button';
import { Text } from '../../atoms/Text/Text';
import { Popup } from '../Popup/Popup';
import { useSideDrawerContext } from './SideDrawerContext';
export function SideDrawerNavItem({ icon, label, onClick, className = '', clickable = true, meta, rightIcon, onRightIconClick, rightIconLabel, children, navButtonRef }) {
    const { collapsed } = useSideDrawerContext();
    const buttonRef = useRef(null);
    const [showSubmenu, setShowSubmenu] = useState(false);
    const hasSubItems = Boolean(children);
    const showRightIcon = Boolean(rightIcon) && !collapsed;
    const showMeta = Boolean(meta) && !collapsed;
    const handleClick = () => {
        if (hasSubItems) {
            setShowSubmenu(!showSubmenu);
        }
        else if (onClick) {
            onClick();
        }
    };
    const handleCloseSubmenu = () => {
        setShowSubmenu(false);
    };
    const handleRightIconClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (onRightIconClick)
            onRightIconClick();
    };
    const handleRightIconKeyDown = (e) => {
        if (e.key !== 'Enter' && e.key !== ' ')
            return;
        e.stopPropagation();
        e.preventDefault();
        if (onRightIconClick)
            onRightIconClick();
    };
    const navItemClasses = [
        'qmb-ui-side-drawer-nav-item',
        showRightIcon ? 'qmb-ui-side-drawer-nav-item--has-right-icon' : '',
        className
    ]
        .filter(Boolean)
        .join(' ');
    const rightIconElement = showRightIcon ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("span", { role: "button", tabIndex: 0, "aria-label": rightIconLabel || 'Action', title: rightIconLabel, className: "qmb-ui-side-drawer-nav-item__right-icon", onClick: handleRightIconClick, onKeyDown: handleRightIconKeyDown }, rightIcon)) : null;
    return (React.createElement(React.Fragment, null,
        clickable ? (React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__wrapper" },
            React.createElement(Button, { ref: (node) => {
                    buttonRef.current = node;
                    if (typeof navButtonRef === 'function') {
                        navButtonRef(node);
                    }
                    else if (navButtonRef) {
                        navButtonRef.current = node;
                    }
                }, type: "button", variant: "default", onClick: handleClick, isMenu: hasSubItems, title: label, className: navItemClasses, style: { justifyContent: collapsed ? 'center' : 'flex-start' } },
                icon && React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__icon" }, icon),
                !collapsed &&
                    (showMeta ? (React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__label-stack" },
                        React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__label" }, label),
                        React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__meta" }, meta))) : (React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__label" }, label)))),
            rightIconElement)) : (React.createElement(Text, { variant: "label", title: label, className: navItemClasses },
            icon && (React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__icon", style: { display: 'flex', alignItems: 'center', width: '16px', height: '16px', flexShrink: 0 } }, icon)),
            !collapsed &&
                (showMeta ? (React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__label-stack" },
                    React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__label" }, label),
                    React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__meta" }, meta))) : (React.createElement("span", { className: "qmb-ui-side-drawer-nav-item__label" }, label))))),
        hasSubItems && (React.createElement(Popup, { anchor: buttonRef.current, show: showSubmenu, onClose: handleCloseSubmenu, containerClass: "qmb-ui-side-drawer-submenu" }, children))));
}
